import React from 'react'

export const Logo = (): React.ReactElement => (
  <img src="/images/logo-black.svg" height={54} alt="Farewill logo" />
)
